// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/react'
import { useFilterStore } from './lib/stores/filter'
import { useMedicationRequestStore } from './lib/stores/medication-request'

Sentry.init({
  environment: import.meta.env.VITE_VERCEL_ENV ?? 'development',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  normalizeDepth: 6,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0,
  propagateTraceparent: true,
  tracePropagationTargets: [
    /^https?:\/\/localhost(:\d+)?(\/.*)?$/,
    /^(?!https?:\/\/clerk\.evaro\.com)(https?:\/\/([a-zA-Z0-9-]+\.)*evaro\.com)(\/.*)?$/
  ],
  debug: false,
  ignoreErrors: [/ChunkLoadError/, /Load failed/],
  beforeSend(event) {
    event.user = window.Clerk ? (window.Clerk.user as any) : undefined
    event.contexts = {
      ...event.contexts,
      additional_info: {
        isOnline: window.navigator.onLine,
        // @ts-ignore
        connection: window.navigator.connection?.effectiveType
      },
      store: {
        filter: useFilterStore.getState(),
        medRequest: useMedicationRequestStore.getState()
      }
    }

    event.tags = {
      ...(event.tags ?? {})
    }

    return event
  },

  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'ui.click') {
      const text = !hint?.event.target.childElementCount
        ? hint?.event.target.innerText
        : hint.event.target.getAttribute('aria-label')
      if (text) {
        breadcrumb.message = text
      }
    }

    return breadcrumb
  }

  // replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  // replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  // integrations: [
  //   Sentry.replayIntegration({
  //     // Additional Replay configuration goes in here, for example:
  //     maskAllText: true,
  //     blockAllMedia: true,
  //   }),
  // ],
})
